import type { GoogleLogin } from '../api/generated/GoogleLogin'
import type { LinkLogin } from '../api/generated/LinkLogin'
import { safeNext } from './next'

export type LoginLink =
  | {
      endpoint: '/auth/link' | '/auth/qr'
      body: LinkLogin
      /** Page to open: invitations and login QR codes are not preceded by the login page. */
      next: string | undefined
    }
  | { endpoint: '/auth/google'; body: GoogleLogin; next: undefined }

/**
 * The secret of a `/login/verify` URL: `token` from an email or `qr` from a login QR code in
 * the fragment, or the `code` Google sends back in the query.
 */
export function parseLoginLink(hash: string, search = ''): LoginLink | undefined {
  const query = new URLSearchParams(search)
  const code = query.get('code')
  const state = query.get('state')
  if (code && state) return { endpoint: '/auth/google', body: { code, state }, next: undefined }

  const fragment = new URLSearchParams(hash.replace(/^#/, ''))
  const next = safeNext(fragment.get('next'))
  const qr = fragment.get('qr')
  if (qr) return { endpoint: '/auth/qr', body: { token: qr }, next }
  const token = fragment.get('token')
  return token ? { endpoint: '/auth/link', body: { token }, next } : undefined
}
